import { Injectable } from '@angular/core';

import { projetoStorage } from "./data.service";
import { ProjetoApiService } from "./projeto-api.service";

@Injectable()
export class ProjetoService {
    constructor(
        private _projetoApiService: ProjetoApiService
    ) {}

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(projetoStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(projetoStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(projetoStorage + "-new");
    }

    getAllProjects() {
        var onDone = (function(response: any) {
            let x: number, lenX: number,
                domain: string = window.location.pathname;

            for (x = 0, lenX = response.length; x < lenX; x++) {
                if (domain.search(response[x]) !== -1) {
                    this.getProject(response[x]);
                    break;
                }
            }
        }.bind(this));

        this._projetoApiService.onGetAll(onDone);
    }

    getProject(tenantName: string) {
        var onDone = (function(response: any) {
            this.setSessionStorage(response);
        }.bind(this));

        this._projetoApiService.onGetByTenantName(tenantName, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projeto/shared/projeto.service.ts
 **/